export const UI_SET_LOADING = 'UI_SET_LOADING'
export const UI_RESET_LOADING = 'UI_RESET_LOADING'
export const UI_SET_MODAL = 'UI_SET_MODAL'
